module.exports = __webpack_public_path__ + "assets/img/5_1177.e59dc2d5.jpg";